import { useCallback, useRef, useState } from 'react';

type AsyncAction<T> = () => Promise<T>;

const useSingleFlightAction = () => {
  const isRunningRef = useRef(false);
  const [isRunning, setIsRunning] = useState(false);

  const runSingleFlight = useCallback(async <T>(action: AsyncAction<T>) => {
    if (isRunningRef.current) return undefined;

    isRunningRef.current = true;
    setIsRunning(true);
    try {
      return await action();
    } finally {
      isRunningRef.current = false;
      setIsRunning(false);
    }
  }, []);

  return { runSingleFlight, isRunning };
};

export default useSingleFlightAction;
